/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection4 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    // window.PXUTheme.jsProductSection4 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);

    this.activeBlock = this.getActiveBlock();

    let mainImageElement = this.element.querySelector(".Section_4");
    this.animationProperties = {
      animation_duration: getComputedStyle(mainImageElement).getPropertyValue("--animation-duration").replace(/\D/g, "")*100
    };

    // It should be gloabal. 
    this.timeouts = {
      main_image: null,
      content_image_1: null,
      content_image_2: null,
      mobile_content_image_1: null,
      mobile_content_image_2: null,
    }

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    }
    this.observer = new IntersectionObserver(this.scrolledIntoView.bind(this), options);
    this.observer.observe(this.element);

    this.delegateElement.on("change", ".Section_4--content--swatch_container input", this.colorChange.bind(this));

    this.handleSmallImagesParallax();
  },
  getActiveBlock() {
    let input = this.element.querySelector("input:checked");
    return input.id;
  },
  colorChange(event, target) {
    this.activeBlock = this.getActiveBlock();
    this.applyAnimation();
  },
  scrolledIntoView(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.applyAnimation();
        this.observer.unobserve(this.element)
      }
    });
  },
  applyAnimation() {
    this.handleImages();
    this.handleBackgroundColor();
  },
  handleImages() {
    let $this = this;
    let blocksToActivate = this.element.querySelectorAll(`[data-block-id="${this.activeBlock}"]`);
    // We should handle 3 images
    for (let blockToActive of blocksToActivate) {

      let timeoutName = blockToActive.getAttribute("data-timeout");

      // Start to load image
      let blockToActive_image = blockToActive.querySelector("img");
      lazySizes.loader.unveil(blockToActive_image);

      // Handle classes for siblings of activeBlock image 
      let blockToActive_siblings = blockToActive.parentNode.querySelectorAll("[data-block-id]");
      for (let blockToActive_sibling of blockToActive_siblings) {
        if (blockToActive_sibling !== blockToActive) {
          blockToActive_sibling.classList.remove("Selected");
        }
      }

      // Clear timeouts of animation. So we won't show miltiple images for multiple swatches clicks
      clearTimeout(this.timeouts[timeoutName]);

      let promiseOfLoading = new Promise((resolve) => {
        if (blockToActive_image.complete && blockToActive_image.naturalHeight !== 0) {
          resolve("loaded");
        } else {
          let interval = setInterval(() => {
            if (blockToActive_image.complete && blockToActive_image.naturalHeight !== 0) {
              resolve("loaded");
              clearInterval(interval);
            }
          }, 10)
        }
      });

      let promiseOfAnimationEnd = new Promise((resolve) => {
        this.timeouts[timeoutName] = setTimeout(()=> resolve("transition ended"), this.animationProperties.animation_duration);
      });
      
      Promise.all([promiseOfLoading, promiseOfAnimationEnd]).then(() => {
        blockToActive.classList.add("Selected");
      });
    }
  },
  handleBackgroundColor() {
    let targetContainer = this.element.querySelector("section.Section_4");
    targetContainer.setAttribute("data-active-block", this.getActiveBlock());
  },
  handleSmallImagesParallax() {
    let image_1 = this.element.querySelector(".Section_4--content--image_2--container");
    let image_2 = this.element.querySelector(".Section_4--mobile_images--image_1--container");
    this.images = [image_1, image_2];
    window.addEventListener("scroll", this.setImagesPosition.bind(this));
  },
  setImagesPosition() {
    this.images.forEach( image => {
      let imageParams = image.getBoundingClientRect();
      let value = (window.innerHeight - (imageParams.top + image.clientHeight / 2)) / window.innerHeight;
      if (value > 1) {
        value = 1;
      } else if (value < 0) {
        value = 0;
      }
      let imageParallaxValue = image.clientHeight > 200 ? 100 : image.clientHeight / 3;
      let top = imageParallaxValue - imageParallaxValue * 2 * value;
      image.style.setProperty("--top", `${top}px`); 
    })
    
  }
}

/******/ })()
;